import React from "react";
import { MFA_LOGIN_V2, PASSWORD_RESET_V2 } from "../../../config/featureFlags";
import ChangePasswordV2 from "./ChangePasswordV2";

// Change Password V2 needs an MFA session (/mfa/password reads it), so it needs MFA login V2 as well as its own flag;
// otherwise the old page renders, untouched (docs/specs/password-reset-stepup.md).
const ChangePasswordGate = ({ Legacy }) => (MFA_LOGIN_V2 && PASSWORD_RESET_V2 ? <ChangePasswordV2 /> : <Legacy />);

export default ChangePasswordGate;
